import React, {useEffect} from 'react';
import CareersHeader from 'app/Components/Page/CellcomCareersPage/Shared/CareersHeader/CareersHeader';
import CareersAd from 'app/Components/Page/CellcomCareersPage/Shared/CareersAd/CareersAd';
import useJob from 'app/Components/Page/CellcomCareersPage/Shared/careersHOC/useJob';
import CareersSubmitReject from 'app/Components/Page/CellcomCareersPage/Shared/CareersSubmitReject/CareersSubmitReject';
import CareersSubmitSuccess from 'app/Components/Page/CellcomCareersPage/Shared/CareersSubmitSuccess/CareersSubmitSuccess';
import Loader from 'app/Components/Shared/LocalLoader/LocalLoader';
import {gtag4} from '../../../utilities/analytics/tracking';

const CareersPage = ({data, context}) => {
  const {
    initAds,
    initUtils,
    initCities,
    initLocation,
    initPageSetting,
    utilsCareersData,
    adsCareersData,
    pageCareersData,
    filterJobData,
    careerScopeList,
    locationCareersData,
    selectedUtils,
    setSelectedScope,
    setCollapseState,
    updateLocation,
    updateScope,
    updateAds,
    locationsRegion,
    selectedScope,
    setSubmitData,
    resumeJobStatus,
    clearLocationFiler,
    clearScopeFilter,
    submitData,
    buttonData,
    cities,
  } = useJob();

  useEffect(() => {
    initLocation(data.careersLocations?.value);
    initUtils(data.careersUtilsJobs?.value);
    initAds(data?.listAdsCareers?.expandedValue);
    initCities();
    initPageSetting(data);
  }, [initLocation, initAds, initUtils, initPageSetting, data]);

  function switchStep() {
    switch (resumeJobStatus) {
      case 'init':
        return (
          <>
            <header className=''>
              <CareersHeader
                data={data}
                utilsJob={utilsCareersData}
                adsCareersData={adsCareersData}
                filterJobData={filterJobData}
                pageCareersSetting={pageCareersData}
                updateAds={updateAds}
                selectedUtils={selectedUtils}
                locationCareersData={locationCareersData}
                careerScopeList={careerScopeList}
                gtag4={gtag4}
              />
            </header>
            <CareersAd
              updateScope={updateScope}
              updateLocation={updateLocation}
              context={context}
              adsCareersData={adsCareersData}
              filterJobData={filterJobData}
              careerScopeList={careerScopeList}
              locationCareersData={locationCareersData}
              selectedUtils={selectedUtils}
              setSelectedScope={setSelectedScope}
              setCollapseState={setCollapseState}
              updateAds={updateAds}
              locationsRegion={locationsRegion}
              selectedScope={selectedScope}
              clearScopeFilter={clearScopeFilter}
              clearLocationFiler={clearLocationFiler}
              setSubmitData={setSubmitData}
              gtag4={gtag4}
              cities={cities}
            />
          </>
        );
      case 'pending':
        return (
          <>
            <CareersHeader
              data={data}
              utilsJob={utilsCareersData}
              adsCareersData={adsCareersData}
              filterJobData={filterJobData}
              pageCareersSetting={pageCareersData}
              updateAds={updateAds}
              selectedUtils={selectedUtils}
              locationCareersData={locationCareersData}
              careerScopeList={careerScopeList}
              gtag4={gtag4}
            />
            <Loader />
          </>
        );
      // Code for "pending" status
      case 'rejected':
        return (
          <>
            <CareersSubmitReject context={context} buttonData={buttonData} />
          </>
        );
      case 'success':
        return <CareersSubmitSuccess context={context} submitData={submitData} buttonData={buttonData} />;
      default:
        // Default case
        break;
    }
  }
  return <div style={{overflowX: 'hidden',whiteSpace:'break-spaces'}}>{switchStep()}</div>;
};
export default CareersPage;
